import {axiosApiInstance} from '../axios';

export const login = (formData) =>{
    return axiosApiInstance.post('/admin/auth/login' , formData);
}

